import { Edit2 } from "lucide-react";

interface UpdateButtonProps {
  id: number;
  email: string;
  onClick: () => void;
}

const UpdateButton: React.FC<UpdateButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md font-medium text-sm transition-colors"
    >
      <Edit2 size={16} />
      Update
    </button>
  );
};

export default UpdateButton;
